export default "__VITE_ASSET__AGjR0hTj__"